import { useState } from "react";
import { Box } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// import required modules
import { FreeMode, Navigation, Pagination, Thumbs, Grid } from "swiper";

//import image
import noImage from "../../../assets/imgs/no-image.png";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import "swiper/css/thumbs";
import "./base-carousel.scss";

function BaseCarousel({
    imageList,
    dir,
    height,
    slidesPerView,
    spaceBetween,
    loop,
    navigation,
    pagination,
    paginationType,
    grid,
    thumbsGallery,
    baseUrl,
}) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <Box className="base-carousel">
            <Swiper
                dir={dir}
                slidesPerView={slidesPerView}
                spaceBetween={spaceBetween}
                loop={loop}
                navigation={navigation}
                pagination={{
                    enabled: pagination,
                    clickable: true,
                    type: paginationType,
                }}
                grid={{
                    rows: grid,
                }}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Pagination, Thumbs, Grid]}
                className="mySwiper2"
                style={{ height }}
            >
                {imageList?.length ? (
                    imageList?.map(imageItem => {
                        return (
                            <SwiperSlide key={Math.random()}>
                                <LazyLoadImage
                                    alt={imageItem?.alt || ""}
                                    src={`${baseUrl}${imageItem?.image}`} // use normal <img> attributes as props
                                />
                                {/* <img ref={imgRef} src={isVisible ? `${baseUrl}${imageItem?.image}` : ""} alt={imageItem?.alt || ""} loading="lazy" /> */}
                            </SwiperSlide>
                        );
                    })
                ) : (
                    <SwiperSlide>
                        <img src={noImage} loading="lazy" />
                    </SwiperSlide>
                )}
            </Swiper>
            {thumbsGallery && (
                <Swiper
                    dir={dir}
                    spaceBetween={10}
                    slidesPerView={5}
                    freeMode={true}
                    watchSlidesProgress={true}
                    onSwiper={setThumbsSwiper}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper"
                >
                    {imageList?.map(imageItem => {
                        return (
                            <SwiperSlide key={Math.random()}>
                                <LazyLoadImage
                                    alt={imageItem?.alt || ""}
                                    src={`${baseUrl}${imageItem?.image}`} // use normal <img> attributes as props
                                />
                                {/* <img src={`${baseUrl}${imageItem?.image}`} loading="lazy" /> */}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            )}
        </Box>
    );
}

export default BaseCarousel;
